import React from "react"
import Root from "./src/layouts/Root.js"


// Wraps every page in a component
const wrapPageElement = ({ element, props }) => {
  return <Root {...props}>{element}</Root>
}

export {wrapPageElement}